import { navigateTo } from '../../../redux/router/routerActions';
import { Link, useLocation } from 'react-router-dom';
import './loginPage.scss'
import { useAppDispatch } from '../../../redux/store';
import { accountSelector, logoutUser, setUserInfo } from '../../../redux/account/accountSlice';
import LoginForm from '../../../Components/Forms/LoginForm/LoginForm';
import { Col, Container, Row } from 'react-bootstrap';
import { useLoginUserMutation } from '../../../services/bClientApi';
import { useSelector } from 'react-redux';

export default function LoginPage() {

  const {username, token} = useSelector(accountSelector)
  const dispatch = useAppDispatch()
  const location = useLocation()

  const [
    loginUser,
    {
      error,
      isLoading
    }
  ] = useLoginUserMutation()
  return (
    <Container>
      <Row>
        <Col>
          <h1>Login Page</h1>
          <hr />
          {error && (
            <>
              {JSON.stringify(error)}
              <br />
              <Link to="forgot-password">Forgot Password?</Link>
            </>
          )}

          {username && token ? (
            <>
              You are already logged in.
              <br /><br />
              <div onClick={() => {
                dispatch(logoutUser())
              }} className="logout-button">click here to logout</div>
            </>
          ) : (
            <LoginForm
              disabled={isLoading}
              onSubmit={async(loginValues: any) => {
                try {
                  const loggedInUser = await loginUser({
                    username: loginValues.email,
                    password: loginValues.password,
                    rememberMe: loginValues.rememberMe
                  }).unwrap()

                  if(loggedInUser && loggedInUser.token) {
                    dispatch(setUserInfo({
                      token: loggedInUser.token,
                      ...loggedInUser.user
                    }))
                  }

                  if(location.pathname === '/login') {
                    dispatch(navigateTo('/'))
                  }
                  return true
                } catch(err) {
                  // custom error handler
                }
                return false
              }}
            />
          )}
        </Col>
      </Row>
    </Container>
  )
}
